<div class="flex flex-col">
    @if(showHeader) {
      <div class="flex items-center justify-between p-2 mb-4 w-full border-b">
        <p class="text-[13px] text-[#475467] font-semibold pt-2 pl-2">
          {{ modalTitle }}
        </p>
      </div>
    }
  
    <div class="mt-4 px-4 flex flex-col">
      <div class="space-y-6">
        <div>
          <p class="text-[#475467] text-sm font-medium mb-2">Filename</p>
          <input
            class="border border-[#D0D5DD] p-2 rounded-lg w-full focus:border-[#0F49A0] focus:outline-none"
            [(ngModel)]="exportFileName"
            placeholder="Enter file name"
          />
        </div>
        
        <div>
          <p class="text-[#475467] text-sm font-medium mb-2">Type</p>
          <div class="export-type-toggle relative bg-gray-100 rounded-lg p-0.5 flex items-center">
            <button 
              class="relative z-10 flex-1 py-2 text-sm font-medium rounded-lg text-center transition-colors duration-300"
              [class.text-white]="exportType === 'TABLE'"
              [class.text-[#475467]]="exportType !== 'TABLE'"
              (click)="setExportType('TABLE')">
              Grid
            </button>
            <button 
              class="relative z-10 flex-1 py-2 text-sm font-medium rounded-lg text-center transition-colors duration-300"
              [class.text-white]="exportType === 'CHART'"
              [class.text-[#475467]]="exportType !== 'CHART'"
              (click)="setExportType('CHART')">
              Chart
            </button>
            <button 
              class="relative z-10 flex-1 py-2 text-sm font-medium rounded-lg text-center transition-colors duration-300"
              [class.text-white]="exportType === 'BOTH'"
              [class.text-[#475467]]="exportType !== 'BOTH'"
              (click)="setExportType('BOTH')">
              Both
            </button>
            <div 
              class="toggle-indicator absolute top-0.5 bottom-0.5 rounded-md bg-[#0F49A0] transition-all duration-300 ease-in-out"
              [ngStyle]="{'left': exportType === 'TABLE' ? '0.5%' : exportType === 'CHART' ? '33.5%' : '67%', 'width': '33%'}">
            </div>
          </div>
        </div>
        
        <div>
          <p class="text-[#475467] text-sm font-medium mb-4">File Format</p>
          <div class="grid grid-cols-5 gap-2">
            @if(exportType === 'TABLE') {
              <div
                *ngFor="let fileType of gridFileTypes"
                class="text-center items-center justify-center flex flex-col rounded-lg p-2 cursor-pointer transition-all duration-200"
                [ngClass]="selectedFormat === fileType.label ? 'bg-[#C3D9FA] scale-105' : 'hover:bg-[#F2F4F7]'"
                (click)="selectFormat(fileType.label)">
                <ui-icon
                  [name]="fileType.icon"
                  [ngClass]="selectedFormat === fileType.label ? 'stroke-[#0F49A0]' : 'stroke-[#344054]'"
                  size="size-8"
                ></ui-icon>
                <p class="text-[#344054] text-xs font-medium mt-1">{{ fileType.label }}</p>
              </div>
            } @else if(exportType === 'CHART') {
              <div
                *ngFor="let fileType of chartFileTypes"
                class="text-center items-center justify-center flex flex-col rounded-lg p-2 cursor-pointer transition-all duration-200"
                [ngClass]="selectedFormat === fileType.label ? 'bg-[#C3D9FA] scale-105' : 'hover:bg-[#F2F4F7]'"
                (click)="selectFormat(fileType.label)">
                <ui-icon
                  [name]="fileType.icon"
                  [ngClass]="selectedFormat === fileType.label ? 'stroke-[#0F49A0]' : 'stroke-[#344054]'"
                  size="size-8"
                ></ui-icon>
                <p class="text-[#344054] text-xs font-medium mt-1">{{ fileType.label }}</p>
              </div>
            } @else {
              <div
                *ngFor="let fileType of bothFileTypes"
                class="text-center items-center justify-center flex flex-col rounded-lg p-2 cursor-pointer transition-all duration-200"
                [ngClass]="selectedFormat === fileType.label ? 'bg-[#C3D9FA] scale-105' : 'hover:bg-[#F2F4F7]'"
                (click)="selectFormat(fileType.label)">
                <ui-icon
                  [name]="fileType.icon"
                  [ngClass]="selectedFormat === fileType.label ? 'stroke-[#0F49A0]' : 'stroke-[#344054]'"
                  size="size-8"
                ></ui-icon>
                <p class="text-[#344054] text-xs font-medium mt-1">{{ fileType.label }}</p>
              </div>
            }
          </div>
        </div>
      </div>
      
      <div class="relative bottom-0 w-full mb-4 border-t border-[#EAECF0] pt-4 bg-white">

        <button
          [disabled]="!canExport"
          class="w-[90%] ml-[5%] text-sm border border-[#D0D5DD] rounded-lg py-2 bg-[#0F49A0] text-white font-medium hover:bg-[#0D3D8B] disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
          (click)="handleExport()">
          Export
        </button>
      </div>
    </div>
  </div>